<template>
  <div class="history-card">
    <v-list-item class="history-card__toolbar">
      <v-icon
        @click="$emit('close-history')"
        class="mr-8"
        data-test-history-back
      >
        mdi-arrow-left
      </v-icon>

      <v-list-item-content>
        <v-list-item-title class="font-weight-medium">
          <slot></slot>
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-action>
        <history-dropdown v-on="$listeners" v-if="!$slots.action" />
        <slot name="action" v-else></slot>
      </v-list-item-action>
    </v-list-item>
    <div class="history-card__content">
      <slot name="list" />
    </div>
  </div>
</template>
<script>
import HistoryDropdown from '@/components/history-card/HistoryDropdown';
export default {
  name: 'HistoryCard',
  components: { HistoryDropdown },
  data() {
    return {
      contextMenu: [
        {
          id: 'edit',
          text: 'Edit',
          icon: 'mdi-pencil'
        },
        {
          id: 'copy',
          text: 'Copy',
          icon: 'mdi-image-filter-none'
        }
      ]
    };
  }
};
</script>

<style lang="sass">


.history-card
  position: absolute
  height: calc(100vh - (44px * 3))
  z-index: 2
  width: 100%
  right: -4px
  @media (max-width: 824px)
    height: 100%

  &__content
    height: calc(100% - 54px)
    overflow: auto

  &__toolbar
    height: 56px
    border-bottom: thin solid rgba(0, 0, 0, 0.12)

.theme--dark .history-card__content
  background: #1E1E1E

.theme--light .history-card__content
  background: #ffffff

.theme--dark .history-card__toolbar
  background: #1E1E1E

.theme--light .history-card__toolbar
  background: #ffffff
</style>
